import React from 'react';
import { useLocation } from 'react-router-dom';
import './App.scss';

import WelcomePage from './WelcomePage';
import TOCPage from './TOCPage';
import SearchPage from './SearchPage';
import FirstRelPage from './FirstRelPage';

function App() {
  const query = new URLSearchParams(useLocation().search);

  const documentLang = window.document.documentElement.getAttribute('lang');

  const lang = query.get('lang') || documentLang || 'hu';
  const q = query.get('q');
  const p = query.get('p') || undefined;
  const themeCode = query.get('theme');
  const frCode = query.get('fr');

  if (q) {
    return <SearchPage q={q} p={p} lang={lang} />;
  } else if (themeCode) {
    return <TOCPage themeCode={themeCode} lang={lang} />;
  } else if (frCode) {
    return <FirstRelPage frCode={frCode} lang={lang} />;
  } else {
    return <WelcomePage lang={lang} />;
  }
}

export default App;
